import './FileBookmarks.scss';

export { default } from './FileBookmarks';
